import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);
  const router = inject(Router);

  const tokenFromUrl = route.queryParamMap.get('token');

  // if (tokenFromUrl !== 'null' && tokenFromUrl !== null) {
  //   authService.saveToken(tokenFromUrl);
  // }

  if (tokenFromUrl !== 'null' && tokenFromUrl !== null) {
    authStore.setSessionFromToken(tokenFromUrl);
    authService.saveToken(tokenFromUrl);

    console.log('token store from url', { tokenFromUrl });

    return router.createUrlTree([state.url.split('?')[0]]);
  }

  const storedToken = authService.getToken();

  if (!storedToken) {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  if (storedToken) {
    if (authStore.user()?.exp) {
      const currentTime = Math.floor(Date.now() / 1000);
      if (authStore.user()?.exp! < currentTime) {
        authStore.logout();
        // return router.parseUrl('/login');
        return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
      }
    }
    return true;
  }

  // return router.parseUrl('/login');
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
